import { DollarSign, ShoppingCart, Tag } from 'lucide-react';
import type { FeatureGroup } from '../types';

export const monetizationGroup: FeatureGroup = {
  id: 'monetization',
  label: 'Monetization',
  headline: 'Turn your CAD skills into income',
  summary:
    'Set a price on any model and let buyers download the STL directly. Payments go through Stripe — no platform cut beyond standard Stripe fees.',
  accentClass: 'from-emerald-500 to-cyan-400',
  items: [
    {
      icon: DollarSign,
      title: 'Paid Downloads',
      description:
        'Set an optional price on any published model. Buyers pay via Stripe and immediately receive a download link for the STL file — fully automated.',
      tier: 'major',
    },
    {
      icon: ShoppingCart,
      title: 'Stripe Integration',
      description:
        'Payment handling is powered by Stripe. Connect your Stripe account and start selling within minutes — no custom billing code required.',
      tier: 'major',
    },
    {
      icon: Tag,
      title: 'Product Mode',
      description:
        'Switch a model into product mode to present it as a polished, purchasable item — clean parameter UI, a price tag, and a download button front and centre.',
      tier: 'minor',
    },
  ],
};
